import type { CSSProperties, ReactNode } from 'react';

type Props = {
  variant: 'square' | 'rectangle' | 'landscape';
  width: number | 'auto';
  height: number | 'auto';
  style?: CSSProperties;
};

const SIZES = {
  square: { width: 90, height: 90 },
  rectangle: { width: 321, height: 106 },
  landscape: { width: 618, height: 65 },
} as const satisfies Record<string, { width: number; height: number }>;

const Logo = ({ variant, width, height, style }: Props): ReactNode => {
  return (
    <img
      src={`/logos/${variant}.svg`}
      alt={'GEOTRA STUDIO'}
      width={SIZES[variant].width}
      height={SIZES[variant].height}
      style={{
        ...style,
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    />
  );
};

export { Logo };
